import {
  VoEResponseAutonomy,
  VoEResponseAutonomyLabels,
} from 'src/graphql/types/verificationOfEmployments'

/**
 * The header-dropdown value for "the employer has not answered yet"
 * (responseAutonomy null). It is not an enum value, so it maps to
 * `noResponseYet` instead of `responseAutonomy`.
 */
export const NO_RESPONSE_YET = 'NO_RESPONSE_YET'

const RESPONSE_AUTONOMY_ORDER: VoEResponseAutonomy[] = [
  VoEResponseAutonomy.AUTONOMOUS,
  VoEResponseAutonomy.ASSISTED,
  VoEResponseAutonomy.MANUAL,
  VoEResponseAutonomy.NO_OUTREACH,
]

export const RESPONSE_FILTER_OPTIONS: { label: string; value: string }[] = [
  ...RESPONSE_AUTONOMY_ORDER.map((value) => ({
    label: VoEResponseAutonomyLabels[value].label,
    value,
  })),
  { label: 'No response yet', value: NO_RESPONSE_YET },
]

const RESPONSE_AUTONOMY_VALUES = new Set<string>(RESPONSE_AUTONOMY_ORDER)

export interface ResponseAutonomyQueryFilters {
  responseAutonomy?: VoEResponseAutonomy[]
  noResponseYet?: boolean
}

/**
 * Maps the Response column's selected options to the list-query filters.
 * The API OR-combines the two: rows whose responseAutonomy is in the list,
 * plus unanswered rows when noResponseYet is true. Unknown values (for
 * example a hand-edited URL) are dropped; nothing selected means no filter.
 */
export const buildResponseAutonomyFilters = (
  selected: string[] | null | undefined
): ResponseAutonomyQueryFilters => {
  const values = selected ?? []
  const responseAutonomy = values.filter((v) =>
    RESPONSE_AUTONOMY_VALUES.has(v)
  ) as VoEResponseAutonomy[]
  const noResponseYet = values.includes(NO_RESPONSE_YET)

  return {
    responseAutonomy: responseAutonomy.length ? responseAutonomy : undefined,
    noResponseYet: noResponseYet || undefined,
  }
}
